import { combineReducers } from 'redux';
import aiAssistantReducer from 'automation-ui-canvas/reducers/resources/aiAssistant';
import subscriptions from 'automation-ui-canvas/reducers/resources/subscriptions';
import workflows from 'automation-ui-canvas/reducers/resources/workflows';
const rootResourcesReducer = combineReducers({
  aiAssistant: aiAssistantReducer,
  subscriptions,
  workflows
});
export default rootResourcesReducer;